import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BolusCompletedPayload = {
  bolus_id: number;
  iob?: number;
  insulin_delivered?: number;
  insulin_requested?: number;
};

export type BolusCompletedEvent = {
  bolusId: number;
  iob?: number;
  insulinDelivered?: number;
  insulinRequested?: number;
};

const bolusCompletedSchema = z.object({
  bolus_id: z.number(),
  iob: cz.permissive(z.number()),
  insulin_delivered: cz.permissive(z.number()),
  insulin_requested: cz.permissive(z.number()),
});

export const LID_BOLUS_COMPLETED = {
  value: 0x14,
  name: "Bolus Completed Event",
  format: "..hfff",
  fields: ["bolus_id", "iob", "insulin_delivered", "insulin_requested"],
  postprocess: rec => ({
    bolusId: rec.bolus_id,
    iob: rec.iob,
    insulinDelivered: rec.insulin_delivered,
    insulinRequested: rec.insulin_requested,
  }),
  schema: bolusCompletedSchema,
} as const satisfies TandemEventDefinition<BolusCompletedPayload, BolusCompletedEvent>;
